import React from "react";
import { connect } from "react-redux";
import Logo from "../../../../components/Logo";
import {
  mojazatKeyfariOptions,
  natijehDaaviMaliOptions,
  noeDaaviGheyrMaliOptions,
  salahiatKeyfariOptions,
} from "../../../../reducer/selectOptions";
import "./index.css";
import Information from "../../../../components/Information";

const Print = ({ type = "mali", header, mali, gheyrMali, keyfari, footer }) => {
  const kanoonMatboVakil = [
    "کانون وکلا",
    "مرکز مشاوران",
    "نماینده قضایی نهادهای دولتی",
  ];
  const noeVekalat = ["تعیینی", "تسخیری", "معاضدتی"];
  const natijeDaavi = [...natijehDaaviMaliOptions];
  const noeDaavi = [...noeDaaviGheyrMaliOptions];
  const salahiat = [...salahiatKeyfariOptions];
  const mojazat = [...mojazatKeyfariOptions];
  const headerData = [
    {
      title: "کانون متبوع وکیل",
      value: "kanoonMatboVakil",
      type: Array,
      data: header,
    },
    {
      title: "نوع وکالت",
      value: "noeVekalat",
      type: Array,
      data: header,
    },
    {
      title: "گواهی وکالت تخصصی",
      value: "govahiVekalatTakhasosi",
      type: Boolean,
      data: header,
    },
    {
      title: "وکالت پس از نقض رای",
      value: "vekalatPasAzNaghzRay",
      type: Boolean,
      data: header,
    },
    {
      title: "روزهای ماموریت داخل استان",
      value: "mamoryatDakhelOstan",
      type: Number,
      data: header,
    },
    {
      title: "روزهای ماموریت خارج استان",
      value: "mamoryatKharejeelOstan",
      type: Number,
      data: header,
    },
  ];
  const maliData = [
    {
      title: "نتیجه دعوی",
      value: "natijeDaavi",
      type: Array,
      data: mali,
      price: null,
    },
    {
      title: header["tarefeYaGharadad"]
        ? "میزان محکوم به / خواسته"
        : "میزان حق الوکاله مورد توافق",
      value: "mizanMahkoomKhaste",
      type: "Price",
      data: mali,
      price: null,
    },
    {
      title: "بدوی",
      value: "badvi",
      type: Boolean,
      data: mali,
      price: footer.badviCost || 0,
    },
    {
      title: "تجدید نظر",
      value: "tajdidNazar",
      type: Boolean,
      data: mali,
      price: footer.tajdidNazarCost || 0,
    },
    {
      title: "دیوان عالی کشور",
      value: "divanAli",
      type: Boolean,
      data: mali,
      price: footer.divanAliCost || 0,
    },
    {
      title: "امور اجرایی",
      value: "omooriEjraii",
      type: Boolean,
      data: mali,
      price: footer.omoorEjraiiCost || 0,
    },
  ];
  const gheyrMaliData = [
    {
      title: "نوع دعوی",
      value: "noeDaavi",
      type: Array,
      data: gheyrMali,
      price: null,
    },
    {
      title: "حق الوکاله پایه",
      value: "hoghooghPaye",
      type: "Price",
      data: gheyrMali,
      price: null,
    },
    {
      title: "بدوی",
      value: "badvi",
      type: Boolean,
      data: gheyrMali,
      price: null,
    },
    {
      title: "تجدید نظر",
      value: "tajdidNazar",
      type: Boolean,
      data: gheyrMali,
      price: null,
    },
    {
      title: "دیوان عالی کشور",
      value: "divanAli",
      type: Boolean,
      data: gheyrMali,
      price: null,
    },
    {
      title: "امور اجرایی",
      value: "omooriEjraii",
      type: Boolean,
      data: gheyrMali,
      price: footer.omoorEjraiiCost || 0,
    },
  ];
  const keyfariData = [
    {
      title: "صلاحیت",
      value: "salahiat",
      type: Array,
      data: keyfari,
      price: null,
    },
    {
      title: "مجازات",
      value: "mojazat",
      type: Array,
      data: keyfari,
      price: null,
    },
    {
      title: "تعداد روز های اضافه",
      value: "tedadJaraemeEzafeh",
      type: Number,
      data: keyfari,
      price: null,
    },
    {
      title: "حق الوکاله پایه",
      value: "hoghooghPaye",
      type: "Price",
      data: keyfari,
      price: null,
    },
    {
      title: "رسیدگی فاقد مرحله دادسرا",
      value: "faghedDadsara",
      type: Boolean,
      data: keyfari,
      price: null,
    },
    {
      title: "دادسرا",
      value: "dadsara",
      type: Boolean,
      data: keyfari,
      price: footer["dadsaraCost"] || 0,
    },
    {
      title: "حکم بدوی قطعی",
      value: "badviGhatii",
      type: Boolean,
      data: keyfari,
      price: null,
    },
    {
      title: "بدوی",
      value: "badvi",
      type: Boolean,
      data: keyfari,
      price: footer["badviCost"],
    },
    {
      title: "تجدید نظر",
      value: "tajdidNazar",
      type: Boolean,
      data: keyfari,
      price: footer["tajdidNazarCost"],
    },
    {
      title: "فرجام خواهی کیفری",
      value: "farjamKhahiKeyfari",
      type: Boolean,
      data: keyfari,
      price: footer["farjamKhahiKeyfariCost"] || 0,
    },
    {
      title: "امور اجرایی",
      value: "omoorEjraii",
      type: Boolean,
      data: keyfari,
      price: footer["omoorEjraiiCost"] || 0,
    },
    {
      title: "اعتراض به قرار های قابل اعتراض دادسرا",
      value: "gharareGhabeleEterazeDadsara",
      type: Boolean,
      data: keyfari,
      price: footer["gharareGhabeleEterazeDadsaraCost"] || 0,
    },
    {
      title: "تقاضای اعاده دادرسی",
      value: "taghazaEadehdadresi",
      type: Boolean,
      data: keyfari,
      price: footer["taghazaEadehDadresiCost"] || 0,
    },
    {
      title: "تقاضای اعمال ماده 477 آیین دادرسی کیفری",
      value: "madde477",
      type: Boolean,
      data: keyfari,
      price: footer["taghazaMade477Cost"] || 0,
    },
  ];
  const footerData = [
    {
      title: "جمع کل حق الوکاله",
      value: "jameHagholvekalehKol",
      type: "Price",
      data: footer,
      show: true,
    },
    {
      title: "هزینه سفر",
      value: "hazinehSafar",
      type: "Price",
      data: footer,
      show: true,
    },
    {
      title: "جمع هزینه سفر و حق الوکاله",
      value: ["jameHagholvekalehKol", "hazinehSafar"],
      type: "Total",
      data: footer,
      show: true,
    },
    {
      title:
        header["kanoonMatboVakil"] === 2
          ? "سهم نماینده قضائی"
          : "حق تمبر مالیاتی",
      value: "haghTambMaliati",
      type: "Price",
      data: footer,
      show: true,
    },
    {
      title:
        header["kanoonMatboVakil"] === 2
          ? "سهم کارمند موثر در پیشرفت دادرسی "
          : "سهم صندوق حمایت",
      value: "sahmSandoghHemayat",
      type: "Price",
      data: footer,
      show: true,
    },
    {
      title: "سهم هزینه کانون وکلا",
      value: "sahmKanoonVokala",
      type: "Price",
      data: footer,
      show: header["kanoonMatboVakil"] !== 2,
    },
    {
      title: "جمع سهم صندوق حمایت, هزینه کانون و تمبر مالیاتی",
      value: ["haghTambMaliati", "sahmSandoghHemayat", "sahmKanoonVokala"],
      type: "Total",
      data: footer,
      show: true,
    },
  ];

  const dataValue = (val, data, type) => {
    if (type === Array) {
      return eval(val)[data[val]];
    }
    if (type === Boolean) {
      return data[val] ? "دارد" : "ندارد";
    }
    if (type === Number) {
      return data[val];
    }
    if (type === "Price") {
      return data[val].toLocaleString() + " ریال";
    }
    if (type === "Total") {
      let total = 0;
      for (let i in val) {
        total += data[val[i]];
      }
      return total.toLocaleString() + " ریال";
    }
  };
  return (
    <div className="Print show-print flex column flex-center pt-5">
      <Logo pageName='محاسبه آنلاین حق الوکاله و تمبر مالیاتی وکلا طبق تعرفه یا قرارداد' />
      <table className="mx-auto">
        <tbody>
          {/* <--- HEADER --->  */}
          <tr>
            <td>محاسبه بر اساس</td>
            <td>{header["tarefeYaGharadad"] ? "تعرفه" : "قرارداد"}</td>
          </tr>
          {headerData.map((item, index) => (
            <tr key={index}>
              <td>{item.title}</td>
              <td>{dataValue(item.value, item.data, item.type)}</td>
            </tr>
          ))}

          {/* <--- MAIN ---> */}
          {eval(`(${type + "Data"})`).map((item, index) => (
            <tr
              key={index}
              style={{
                display:
                  item.type === Boolean && !item.data[item.value] ? "none" : "",
              }}
            >
              <td>{item.title}</td>
              <td>{dataValue(item.value, item.data, item.type)}</td>
              {item.price !== null ? (
                // <td>{dataValue(item.price, item.data, "Price")}</td>
                <td>{item.price.toLocaleString() + " ریال"}</td>
              ) : null}
            </tr>
          ))}

          {/* <--- FOOTER ---> */}
          {footerData.map((item, index) => (
            <tr key={index} show={item.show.toString()}>
              <td>{item.title}</td>
              <td></td>
              <td>{dataValue(item.value, item.data, item.type)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    header: state.header,
    mali: state.mali,
    gheyrMali: state.gheyrMali,
    keyfari: state.keyfari,
    footer: state.footer,
  };
};

export default connect(mapStateToProps)(Print);
